import dayjs from 'dayjs';

export const misionData = [
 
  // {
  //   id: 5,
  //   missionName: "Coding Challenge",
  //   description: "Solve 30 coding problems to improve skills",
  //   valueTag: "Skills",
  //   difficulty: "Hard",
  //   schedule: "Weekly",
  //   startDate: dayjs('2024-01-25').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-03-25').format('YYYY-MM-DD'),
  //   missionPoint: 300,
  //   onHoliday: false,
  //   approval: false,
  //   penalty: true,
  //   penaltyPoint: 50,
  //   status: "Completed",
  //   createdDate: dayjs('2024-01-20').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-20').format('YYYY-MM-DD'),
  //   createdBy: "Tech Lead"
  // },
  // {
  //   id: 20034,
  //   missionName: "Language Learning",
  //   description: "Learn 50 new words weekly in foreign language",
  //   valueTag: "Education",
  //   difficulty: "Medium",
  //   schedule: "Weekly",
  //   startDate: dayjs('2024-02-15').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-04-15').format('YYYY-MM-DD'),
  //   missionPoint: 150,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 25,
  //   status: "Active",
  //   createdDate: dayjs('2024-02-10').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-02-10').format('YYYY-MM-DD'),
  //   createdBy: "Language Dept"
  // },
  // {
  //   id: 20081,
  //   missionName: "Volunteer Hours",
  //   description: "Complete 20 volunteer hours for community service",
  //   valueTag: "Community",
  //   difficulty: "Medium",
  //   schedule: "Monthly",
  //   startDate: dayjs('2024-03-01').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-06-01').format('YYYY-MM-DD'),
  //   missionPoint: 250,
  //   onHoliday: false,
  //   approval: false,
  //   penalty: false,
  //   penaltyPoint: 0,
  //   status: "Upcoming",
  //   createdDate: dayjs('2024-02-20').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-02-20').format('YYYY-MM-DD'),
  //   createdBy: "HR Team"
  // },
  // {
  //   id: 20083,
  //   missionName: "Budget Planning",
  //   description: "Create and stick to monthly budget plan",
  //   valueTag: "Finance",
  //   difficulty: "Medium",
  //   schedule: "Monthly",
  //   startDate: dayjs('2024-02-01').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-12-01').format('YYYY-MM-DD'),
  //   missionPoint: 175,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 30,
  //   status: "Active",
  //   createdDate: dayjs('2024-01-28').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-28').format('YYYY-MM-DD'),
  //   createdBy: "Finance Dept"
  // },
  // {
  //   id: 20084,
  //   missionName: "Photo Challenge",
  //   description: "Take one creative photo daily to boost creativity",
  //   valueTag: "Creativity",
  //   difficulty: "Easy",
  //   schedule: "Daily",
  //   startDate: dayjs('2024-02-05').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-03-05').format('YYYY-MM-DD'),
  //   missionPoint: 90,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 18,
  //   status: "Active",
  //   createdDate: dayjs('2024-01-30').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-30').format('YYYY-MM-DD'),
  //   createdBy: "Creative Team"
  // },
  // {
  //   id: 20080,
  //   missionName: "Team Building",
  //   description: "Organize team lunch monthly for better bonding",
  //   valueTag: "Social",
  //   difficulty: "Easy",
  //   schedule: "Monthly",
  //   startDate: dayjs('2024-02-15').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-05-15').format('YYYY-MM-DD'),
  //   missionPoint: 120,
  //   onHoliday: false,
  //   approval: false,
  //   penalty: false,
  //   penaltyPoint: 0,
  //   status: "Pending",
  //   createdDate: dayjs('2024-02-01').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-02-01').format('YYYY-MM-DD'),
  //   createdBy: "Team Lead"
  // },
  //  {
  //   id: 1,
  //   missionName: "Morning Run Challenge",
  //   description: "Complete 5km run before 8 AM daily",
  //   valueTag: "Fitness",
  //   difficulty: "Medium",
  //   schedule: "Daily",
  //   startDate: dayjs('2024-01-15').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-02-15').format('YYYY-MM-DD'),
  //   missionPoint: 100,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 20,
  //   status: "Active",
  //   createdDate: dayjs('2024-01-10').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-10').format('YYYY-MM-DD'),
  //   createdBy: "Admin"
  // },
  // {
  //   id: 2,
  //   missionName: "Reading Marathon",
  //   description: "Read 10 books in one month",
  //   valueTag: "Education",
  //   difficulty: "Hard",
  //   schedule: "Weekly",
  //   startDate: dayjs('2024-02-01').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-03-01').format('YYYY-MM-DD'),
  //   missionPoint: 200,
  //   onHoliday: false,
  //   approval: false,
  //   penalty: false,
  //   penaltyPoint: 0,
  //   status: "Pending",
  //   createdDate: dayjs('2024-01-25').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-25').format('YYYY-MM-DD'),
  //   createdBy: "Manager"
  // },
  // {
  //   id: 3,
  //   missionName: "Water Intake Tracker",
  //   description: "Drink 2L water daily for better health",
  //   valueTag: "Health",
  //   difficulty: "Easy",
  //   schedule: "Daily",
  //   startDate: dayjs('2024-01-20').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-02-20').format('YYYY-MM-DD'),
  //   missionPoint: 50,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 10,
  //   status: "Active",
  //   createdDate: dayjs('2024-01-15').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-01-15').format('YYYY-MM-DD'),
  //   createdBy: "Health Coach"
  // },
  // {
  //   id: 4,
  //   missionName: "Meditation Practice",
  //   description: "Meditate for 15 minutes daily for mindfulness",
  //   valueTag: "Wellness",
  //   difficulty: "Easy",
  //   schedule: "Daily",
  //   startDate: dayjs('2024-02-10').format('YYYY-MM-DD'),
  //   endDate: dayjs('2024-03-10').format('YYYY-MM-DD'),
  //   missionPoint: 75,
  //   onHoliday: true,
  //   approval: true,
  //   penalty: true,
  //   penaltyPoint: 15,
  //   status: "Active",
  //   createdDate: dayjs('2024-02-05').format('YYYY-MM-DD'),
  //   lastCreatedDate: dayjs('2024-02-05').format('YYYY-MM-DD'),
  //   createdBy: "Wellness Team"
  // },
];